import extend from './extend.js';

export enum Role {
  Expert           = 1,
  FirmCompliance   = 2,
  FirmAnalyst      = 3,
  InternalAdmin    = 4,
  FirmTransient    = 5,
  Recruiter        = 6,
  DataSteward      = 7,
  InsightsChatOnly = 8,
}

const map = new Map([
  [Role.Expert,           { name: 'expert' }],
  [Role.FirmCompliance,   { name: 'firm-compliance' }],
  [Role.FirmAnalyst,      { name: 'firm-analyst' }],
  [Role.InternalAdmin,    { name: 'internal-admin' }],
  [Role.FirmTransient,    { name: 'firm-transient' }],
  [Role.Recruiter,        { name: 'recruiter' }],
  [Role.DataSteward,      { name: 'data-steward' }],
  [Role.InsightsChatOnly, { name: 'insights-chat-only' }],
]);

export enum Seniority {
  CLevel      = 1,
  Executive   = 2,
  Director    = 3,
  Manager     = 4,
  NonManager  = 5,
  Other       = 6,
}

const seniorityMap = new Map([
  [Seniority.CLevel, { name: 'C-Level' }],
  [Seniority.Executive, { name: 'Executive' }],
  [Seniority.Director, { name: 'Director' }],
  [Seniority.Manager, { name: 'Manager' }],
  [Seniority.NonManager, { name: 'Non Manager' }],
  [Seniority.Other, { name: 'Other' }],
]);

export default {
  Role: extend(map),
  Seniority: extend(seniorityMap),
};